<!--main section-->
<main-section></main-section>
<!--main features-->
<main-features></main-features>
<!--extra features-->
<extra-features></extra-features>
<!--download-->
<component-download></component-download>
<!--contact-->
<component-contact></component-contact>